import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ApiResponse } from "@biletix/core/models/api-response";
import { TFFClubDto } from "@biletix/core/models/tff/TFFClubDto";
import { ApiService } from "@biletix/core/services/api.service";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import {TFFCountryDto} from "@biletix/core/models/tff/TFFCountryDto";
import {TFFCityDto} from "@biletix/core/models/tff/TFFCityDto";
import {TFFTownDto} from "@biletix/core/models/tff/TFFTownDto";

@Injectable()
export class TffConstantService {

  private tffBasePath: string = "/api/v1/tff/constant";

  constructor(private http: HttpClient,
              private apiService: ApiService) {
  }

  getCountyList(): Observable<TFFCountryDto[]> {
    return this.http
      .get<ApiResponse<TFFCountryDto[]>>(`${this.apiService.getCrmApiHost()}${this.tffBasePath}/country/list`)
      .pipe(map(response => response.data))
  }

  getCityList(countryId:string): Observable<TFFCityDto[]> {
    return this.http
      .get<ApiResponse<TFFCityDto[]>>(`${this.apiService.getCrmApiHost()}${this.tffBasePath}/city/list/${countryId}`)
      .pipe(map(response => response.data))
  }

  getTownList(cityId:string): Observable<TFFTownDto[]> {
    return this.http
      .get<ApiResponse<TFFTownDto[]>>(`${this.apiService.getCrmApiHost()}${this.tffBasePath}/town/list/${cityId}`)
      .pipe(map(response => response.data))
  }

}

